import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { USER_STATUSES } from "@/api/types";
import { UsersPage } from "@/features/users/users-page";
import { baseListSearch, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/users/")({
  validateSearch: z.object({
    ...baseListSearch,
    organizationId: optionalString,
    storeId: optionalString,
    status: optionalEnum(USER_STATUSES),
    role: optionalString,
    preview: optionalString,
  }),
  head: () => ({ meta: [{ title: "Users · Rogue Admin" }] }),
  component: UsersPage,
});
